// extracted by mini-css-extract-plugin
export default {"root":"PrimaryInfo_root__Ve9IK","info":"PrimaryInfo_info__-svBA"};